import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-018e6726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-0 custom-actividad" }
const _hoisted_2 = {
  key: 0,
  class: "row gx-0"
}
const _hoisted_3 = { class: "d-block d-lg-none p-3" }
const _hoisted_4 = { class: "col-12 col-lg-6 p-5 custom-actividad-columna1" }
const _hoisted_5 = { class: "fw-bold text-uppercase" }
const _hoisted_6 = { class: "mb-4 text-uppercase" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "col-12 col-lg-6 custom-actividad-columna2 p-5" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "d-none d-lg-block col-12 mb-5" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "col-12 mb-5"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}

import { onMounted, ref } from 'vue'
import { activityService } from '@/services/activity.service'

import { useRoute } from 'vue-router'

import VMensajeExclusividad from '@/components/rebranding/VMensajeExclusividad.vue'

import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import TheReserveDay from './detail/TheReserveDay.vue'
import TheSorteo from '@/components/TheSorteo.vue'
import TheCupones from '@/components/TheCupones.vue'
import TheCuponesTienda from '@/components/TheCuponesTienda.vue'
import TheRecital from '@/components/rebranding/TheRecital.vue'
import VCarousel from '@/components/rebranding/VCarousel.vue'
import AppContentButtonsComponent from '@/components/AppContentButtonsComponent.vue'

// import state from '@/store/state'
// import TheReserveDay from './detail/TheReserveDay.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleActividad',
  setup(__props) {

const { state, getters, commit } = useStore<VuexStore>(key)

const route = useRoute()

const loading = ref(true)
const error = ref(false)
const actividadVer = ref()

onMounted(async () => {

  console.log(getters.actualFormularioURL)
  try {
    error.value = false
    loading.value = true

    const idActividad = parseInt(route.params?.actividadId.toString()) ?? 0
    const data = await activityService.ver(idActividad)
    console.log(data)

    commit('COMPLETE_ACTIVIDAD_REBRANDING', data)

    console.log(getters.actualFormularioURL)

    actividadVer.value = data
    loading.value = false
  } catch (e) {
    error.value = true
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (actividadVer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(VCarousel, {
              slider: actividadVer.value.slider,
              "activididad-id": actividadVer.value.id
            }, null, 8, ["slider", "activididad-id"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(actividadVer.value.nombre), 1),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(actividadVer.value.subtitulo), 1),
            _createElementVNode("small", {
              innerHTML: actividadVer.value.descripcion
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                ([46, 76, 115, 123, 70, 179].includes(actividadVer.value.id))
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      class: "w-100 rounded-3",
                      muted: "",
                      src: `/video/promo_${actividadVer.value.id}.mp4`,
                      autoplay: "",
                      controls: ""
                    }, null, 8, _hoisted_11))
                  : (_openBlock(), _createBlock(VCarousel, {
                      key: 1,
                      slider: actividadVer.value.slider,
                      "activididad-id": actividadVer.value.id
                    }, null, 8, ["slider", "activididad-id"]))
              ]),
              ((actividadVer.value.exclusivo || actividadVer.value.registrados) && actividadVer.value.tipo !== 'Info')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_unref(state).evento?.marca)
                      ? (_openBlock(), _createBlock(VMensajeExclusividad, {
                          key: 0,
                          nombreEvento: actividadVer.value.nombre,
                          marca: _unref(state).evento.marca,
                          soloRegistrados: actividadVer.value.registrados,
                          soloFidelizados: actividadVer.value.fidelizados
                        }, null, 8, ["nombreEvento", "marca", "soloRegistrados", "soloFidelizados"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!actividadVer.value.exclusivo && !actividadVer.value.registrados)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (actividadVer.value.tipo === 'sorteo')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(TheSorteo, {
                            id: actividadVer.value.id
                          }, null, 8, ["id"])
                        ]))
                      : _createCommentVNode("", true),
                    (actividadVer.value.tipo === 'cupones')
                      ? (_openBlock(), _createBlock(TheCupones, {
                          key: 1,
                          id: actividadVer.value.id,
                          nombre: actividadVer.value.nombre
                        }, null, 8, ["id", "nombre"]))
                      : _createCommentVNode("", true),
                    (actividadVer.value.tipo === 'cupones_tienda')
                      ? (_openBlock(), _createBlock(TheCuponesTienda, {
                          key: 2,
                          id: actividadVer.value.id,
                          nombre: actividadVer.value.nombre
                        }, null, 8, ["id", "nombre"]))
                      : _createCommentVNode("", true),
                    (actividadVer.value.tipo === 'Recital')
                      ? (_openBlock(), _createBlock(TheRecital, {
                          key: 3,
                          actividad: actividadVer.value
                        }, null, 8, ["actividad"]))
                      : _createCommentVNode("", true),
                    (
                actividadVer.value.tipo === 'Academy' ||
                actividadVer.value.tipo === 'academy_fidelizacion'
              )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createVNode(TheReserveDay, {
                            actividad: actividadVer.value,
                            "con-acceso-vip": false
                          }, null, 8, ["actividad"]),
                          _createVNode(AppContentButtonsComponent, {
                            "disabled-return": false,
                            "go-back": _unref(getters).actualUbicacionURL,
                            disabledContinue: !_unref(state).navigation.turno,
                            urlRedirect: _unref(getters).actualFormularioURL
                          }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (actividadVer.value.tipo === 'cupos_limitados')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createVNode(TheReserveDay, {
                            actividad: actividadVer.value,
                            "con-acceso-vip": false
                          }, null, 8, ["actividad"]),
                          _createVNode(AppContentButtonsComponent, {
                            "disabled-return": false,
                            "go-back": _unref(getters).actualUbicacionURL,
                            disabledContinue: !_unref(state).navigation.turno,
                            urlRedirect: _unref(getters).actualFormularioURL
                          }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})